import { useEffect, useRef, useState } from "react";
import MenuLayout from "../../layouts/MenuLayout";
import { useNavigate } from "react-router-dom";
import { coachPaths } from "../../routes/coach";
import { useDispatch, useSelector } from "react-redux";
import { fetchCoachList } from "../../redux/features/coach/actions/coachAction";
import Loader from "../../components/loader";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";
import ClientSlider from "../../components/slider/ClientSlider";
import { curSym } from "../../utils/pip";

const FundingProjectFullDetail = () => {
  const user = { name: "founder-coaching", role: "coach" };
  const { isLoading2, coachList } = useSelector((state) => state.coach.coach);
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const navigate = useNavigate();

  //   const [navBarDemo, setNavBarDemo] = useState("Founder");

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  if (isLoading2) {
    return <Loader />;
  }
  return (
    <MenuLayout user={user}>
      {({ openSignUp }) => (
        <>
          <div className="ct_px_40 pt-4">
            <section className="ct_funding_project_detail_hero">
              <div className="text-white">
                <h2 className="ct_fs_50 text-center ct_mb_30">
                  Solar Learning{" "}
                  <span className="ct_yellow_text">Initiative</span>
                </h2>
                <p className="mb-0 ct_fs_20_new text-center">
                  Empowering rural schools through solar-powered learning tools
                </p>
                <div className="d-flex align-items-center justify-content-center gap-3 ct_flex_col_575 ct_mt_30">
                  <button
                    className="ct_yellow_btn px-5 ct_outline_yellow_new ct_yellow_text"
                    data-bs-target="#ct_contact_founder_modal"
                    data-bs-toggle="modal"
                  >
                    Contact Founder
                  </button>
                  <button
                    className="ct_yellow_btn px-5"
                    data-bs-target="#ct_back_this_founder_modal"
                    data-bs-toggle="modal"
                  >
                    Back This Founder
                  </button>
                </div>
              </div>
            </section>
          </div>

          <section
            class="ct_mt_130"
            data-aos="fade-top"
            data-aos-duration="1500"
          >
            <h4 class="ct_fs_24_new  text-center">
              Join the 1,200+ companies growing with us{" "}
            </h4>
            <ClientSlider />
          </section>

          <section class="ct_py_130">
            <div class="container">
              <div class="row align-items-center gy-4">
                <div class="col-lg-5 mb-5 mb-lg-0">
                  <div className="position-relative">
                    <div class="ct_img_left h-100">
                      <img
                        src="../assets/img/education_single_img_main.png"
                        alt="children learning"
                      />
                    </div>

                    <div className="ct_stack_images">
                      <div class="ct_img_right">
                        <img
                          src="../assets/img/education_stack_img_1.png"
                          alt="kids smiling"
                        />
                      </div>
                      <div class="ct_img_right">
                        <img
                          src="../assets/img/education_stack_img_2.png"
                          alt="happy children"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-7 mb-5 mb-lg-0">
                  <div class="ct_education_content ps-lg-4">
                    <h3
                      class="ct_fs_32 ct_yellow_text ct_mb_40"
                      style={{ maxWidth: "600px" }}
                    >
                      Powering Education Where It’s Needed Most
                    </h3>

                    <p className="ct_fs_20_new ct_darkblue_text ct_mb_10">
                      This project delivers solar-powered learning hubs to
                      remote communities in Africa bringing electricity, offline
                      digital content, and local mentorship to learners with
                      limited access to schools or internet.
                    </p>

                    <p className="ct_fs_20_new ct_darkblue_text mb-0">
                      Each learning station include:{" "}
                    </p>

                    <ul className="ct_mb_16 ps-5" style={{ listStyle: "disc" }}>
                      <li className="ct_fs_20_new ct_darkblue_text ">
                        Solar panels powering lights, tablets, and routers
                      </li>
                      <li className="ct_fs_20_new ct_darkblue_text ">
                        Preloaded curriculum in local languages
                      </li>
                      <li className="ct_fs_20_new ct_darkblue_text ">
                        Offline access to STEM, literacy, and vocational content
                      </li>
                    </ul>

                    <p className="ct_fs_20_new ct_darkblue_text ">
                      With solar energy and tailored tools, we’re creating
                      brighter futures, one village at a time.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <div className="ct_px_40">
            <section class="ct_project_v2">
              <div class="container-fluid">
                <div class="ct_project_box">
                  <div class="row gy-4 align-items-center">
                    <div class="col-lg-6">
                      <div class="ct_project_left">
                        <h3
                          className="ct_fs_40 mb-5"
                          style={{ maxWidth: "410px" }}
                        >
                          The Project at a Glance: Our{" "}
                          <span className="ct_yellow_text">Mission</span> &
                          Goals
                        </h3>

                        <p
                          className="ct_fs_20_new ct_para_scroll ct_custom_scroll mb-0"
                          style={{ maxWidth: "543px" }}
                        >
                          Focused on four key pillars, this initiative drives
                          scalable, tech-powered learning to underserved
                          communities with a mission to reach 10,000 learners
                          across 20 rural villages by next year.
                        </p>

                        <div className="ct_mt_40">
                          <a
                            href="#"
                            class="ct_yellow_btn px-5 ct_fit_content"
                            data-bs-target="#ct_back_this_founder_modal"
                            data-bs-toggle="modal"
                          >
                            Back This Founder
                          </a>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-6">
                      <div class="row g-3">
                        <div class="col-md-6">
                          <div class="ct_info_card">
                            <div>
                              <div class="ct_card_icon">
                                <img src="../assets/img/game-icons_world.png" />
                              </div>
                              <h6>Community Reach</h6>
                              <p className="ct_para_scroll ct_custom_scroll mb-0">
                                Over 5,000 learners across remote regions now
                                have access to digital education through
                                solar-powered learning hubs.
                              </p>
                            </div>
                            <div className="ct_pt_30 text-end mt-auto">
                              <svg
                                width="40"
                                height="40"
                                viewBox="0 0 40 40"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="27.5157"
                                  width="30"
                                  height="30"
                                  rx="15"
                                  transform="rotate(66.5188 27.5157 0)"
                                  fill="#219EBC"
                                />
                                <path
                                  d="M24.7672 26.3254L28.9049 15.7511L18.3522 11.5586C18.248 11.5003 18.1325 11.4651 18.0136 11.4553C17.8946 11.4455 17.7749 11.4614 17.6626 11.5019C17.5503 11.5424 17.448 11.6065 17.3626 11.69C17.2773 11.7735 17.2109 11.8743 17.1679 11.9857C17.1249 12.097 17.1063 12.2164 17.1134 12.3355C17.1206 12.4547 17.1532 12.5709 17.2092 12.6764C17.2651 12.7818 17.3431 12.8741 17.4378 12.9468C17.5324 13.0195 17.6417 13.071 17.758 13.0978L25.6608 16.2518L11.0392 22.6037C10.8365 22.6918 10.6771 22.8568 10.596 23.0624C10.5149 23.268 10.5189 23.4974 10.6069 23.7001C10.695 23.9028 10.86 24.0622 11.0656 24.1433C11.2712 24.2244 11.5006 24.2205 11.7033 24.1324L26.3249 17.7805L23.2366 25.7092C23.1563 25.9152 23.161 26.1447 23.2498 26.3472C23.3387 26.5497 23.5043 26.7087 23.7103 26.7891C23.9163 26.8694 24.1458 26.8647 24.3483 26.7759C24.5508 26.687 24.7098 26.5214 24.7902 26.3154L24.7672 26.3254Z"
                                  fill="white"
                                />
                              </svg>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="ct_info_card">
                            <div>
                              <div class="ct_card_icon">
                                <img src="../assets/img/setting_icon_set.png" />
                              </div>
                              <h6>Active Progress</h6>
                              <p className="ct_para_scroll ct_custom_scroll mb-0">
                                Three pilot hubs are currently running, with
                                trained local facilitators and offline-first
                                content creating new educational pathways.
                              </p>
                            </div>
                            <div className="ct_pt_30 mt-auto text-end">
                              <svg
                                width="40"
                                height="40"
                                viewBox="0 0 40 40"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="27.5157"
                                  width="30"
                                  height="30"
                                  rx="15"
                                  transform="rotate(66.5188 27.5157 0)"
                                  fill="#FFB703"
                                />
                                <path
                                  d="M24.7672 26.3254L28.9049 15.7511L18.3522 11.5586C18.248 11.5003 18.1325 11.4651 18.0136 11.4553C17.8946 11.4455 17.7749 11.4614 17.6626 11.5019C17.5503 11.5424 17.448 11.6065 17.3626 11.69C17.2773 11.7735 17.2109 11.8743 17.1679 11.9857C17.1249 12.097 17.1063 12.2164 17.1134 12.3355C17.1206 12.4547 17.1532 12.5709 17.2092 12.6764C17.2651 12.7818 17.3431 12.8741 17.4378 12.9468C17.5324 13.0195 17.6417 13.071 17.758 13.0978L25.6608 16.2518L11.0392 22.6037C10.8365 22.6918 10.6771 22.8568 10.596 23.0624C10.5149 23.268 10.5189 23.4974 10.6069 23.7001C10.695 23.9028 10.86 24.0622 11.0656 24.1433C11.2712 24.2244 11.5006 24.2205 11.7033 24.1324L26.3249 17.7805L23.2366 25.7092C23.1563 25.9152 23.161 26.1447 23.2498 26.3472C23.3387 26.5497 23.5043 26.7087 23.7103 26.7891C23.9163 26.8694 24.1458 26.8647 24.3483 26.7759C24.5508 26.687 24.7098 26.5214 24.7902 26.3154L24.7672 26.3254Z"
                                  fill="white"
                                />
                              </svg>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="ct_info_card">
                            <div>
                              <div class="ct_card_icon">
                                <img src="../assets/img/mingcute_rocket-fill.png" />
                              </div>
                              <h6>Scaling Forward</h6>
                              <p className="ct_para_scroll ct_custom_scroll mb-0">
                                Our next rollout covers 15 additional
                                communities. The model is scalable,
                                community-owned, and designed for long-term
                                sustainability.
                              </p>
                            </div>
                            <div className="ct_pt_30 mt-auto text-end">
                              <svg
                                width="40"
                                height="40"
                                viewBox="0 0 40 40"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="27.5157"
                                  width="30"
                                  height="30"
                                  rx="15"
                                  transform="rotate(66.5188 27.5157 0)"
                                  fill="#219EBC"
                                />
                                <path
                                  d="M24.7672 26.3254L28.9049 15.7511L18.3522 11.5586C18.248 11.5003 18.1325 11.4651 18.0136 11.4553C17.8946 11.4455 17.7749 11.4614 17.6626 11.5019C17.5503 11.5424 17.448 11.6065 17.3626 11.69C17.2773 11.7735 17.2109 11.8743 17.1679 11.9857C17.1249 12.097 17.1063 12.2164 17.1134 12.3355C17.1206 12.4547 17.1532 12.5709 17.2092 12.6764C17.2651 12.7818 17.3431 12.8741 17.4378 12.9468C17.5324 13.0195 17.6417 13.071 17.758 13.0978L25.6608 16.2518L11.0392 22.6037C10.8365 22.6918 10.6771 22.8568 10.596 23.0624C10.5149 23.268 10.5189 23.4974 10.6069 23.7001C10.695 23.9028 10.86 24.0622 11.0656 24.1433C11.2712 24.2244 11.5006 24.2205 11.7033 24.1324L26.3249 17.7805L23.2366 25.7092C23.1563 25.9152 23.161 26.1447 23.2498 26.3472C23.3387 26.5497 23.5043 26.7087 23.7103 26.7891C23.9163 26.8694 24.1458 26.8647 24.3483 26.7759C24.5508 26.687 24.7098 26.5214 24.7902 26.3154L24.7672 26.3254Z"
                                  fill="white"
                                />
                              </svg>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="ct_info_card">
                            <div>
                              <div class="ct_card_icon">
                                <img src="../assets/img/fa6-solid_handshake.png" />
                              </div>
                              <h6>Partnership Opportunity</h6>
                              <p className="ct_para_scroll ct_custom_scroll mb-0">
                                We're raising {curSym} 75,000 in total with {curSym} 28,000
                                already committed. Support can come through
                                grants, co-investment, or partnerships.
                              </p>
                            </div>
                            <div className="ct_pt_30 mt-auto text-end">
                              <svg
                                width="40"
                                height="40"
                                viewBox="0 0 40 40"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="27.5157"
                                  width="30"
                                  height="30"
                                  rx="15"
                                  transform="rotate(66.5188 27.5157 0)"
                                  fill="#219EBC"
                                />
                                <path
                                  d="M24.7672 26.3254L28.9049 15.7511L18.3522 11.5586C18.248 11.5003 18.1325 11.4651 18.0136 11.4553C17.8946 11.4455 17.7749 11.4614 17.6626 11.5019C17.5503 11.5424 17.448 11.6065 17.3626 11.69C17.2773 11.7735 17.2109 11.8743 17.1679 11.9857C17.1249 12.097 17.1063 12.2164 17.1134 12.3355C17.1206 12.4547 17.1532 12.5709 17.2092 12.6764C17.2651 12.7818 17.3431 12.8741 17.4378 12.9468C17.5324 13.0195 17.6417 13.071 17.758 13.0978L25.6608 16.2518L11.0392 22.6037C10.8365 22.6918 10.6771 22.8568 10.596 23.0624C10.5149 23.268 10.5189 23.4974 10.6069 23.7001C10.695 23.9028 10.86 24.0622 11.0656 24.1433C11.2712 24.2244 11.5006 24.2205 11.7033 24.1324L26.3249 17.7805L23.2366 25.7092C23.1563 25.9152 23.161 26.1447 23.2498 26.3472C23.3387 26.5497 23.5043 26.7087 23.7103 26.7891C23.9163 26.8694 24.1458 26.8647 24.3483 26.7759C24.5508 26.687 24.7098 26.5214 24.7902 26.3154L24.7672 26.3254Z"
                                  fill="white"
                                />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <section
            data-aos="fade-right"
            data-aos-duration="1500"
            class="ct_looking_for_work_bg ct_looking_for_work_bg_left  ct_mt_100"
            style={{ backgroundColor: "#FB8500", paddingBlock: "134px" }}
          >
            <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
              <div class="text-white">
                <h4 class="ct_fs_36 mb-4">
                  Help Us Power the Next Learning Hub
                </h4>
                <p
                  class="mb-0 ct_fs_18 ct_fw_300"
                  style={{ maxWidth: "680px" }}
                >
                  Your support can bring solar energy, mentorship and
                  opportunity to a new community and change lives for
                  generations to come
                </p>
              </div>
              <div class="ct_flex_shrink_0 ms-lg-auto">
                <a
                  class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
                  data-bs-target="#ct_back_this_founder_modal"
                  data-bs-toggle="modal"
                // onClick={() => navigate(coachPaths?.ContactUs)}
                >
                  Back a Founder Today
                </a>
              </div>
            </div>
          </section>

          <section class=" ct_px_40 ct_py_130">
            <div class="container-fluid">
              <div class="row align-items-center">
                <div
                  class="col-lg-4 mb-4 mb-lg-0 aos-init aos-animate"
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <div class="ct_how_work_img">
                    <img
                      src="../assets/img/simple_way_to_support_home.png"
                      alt=""
                      style={{ objectFit: "cover", objectPosition: "right" }}
                    />
                  </div>
                </div>
                <div
                  class="col-lg-8 mb-4 mb-lg-0 aos-init aos-animate ps-lg-5"
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <div class="ct_how_work_content">
                    <h4 class="ct_fs_24_new ct_dakrblue_text">How It Works?</h4>
                    <h3 class="ct_fs_32 ct_dakrblue_text ">
                      Three Simple Ways To Support
                    </h3>
                  </div>
                  <div class="row mt-5">
                    <div class="col-lg-4">
                      <div class="ct_how_work_card">
                        <img
                          src="../assets/img/ri_find-replace-fill.png"
                          alt=""
                          className="ct_w_50_340"
                        />
                        <div class="pt-4">
                          <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                            Explore Projects
                          </h5>
                          <p
                            class="mb-0 ct_fs_16"
                            style={{ maxWidth: "262px" }}
                          >
                            Browse our curated ideas by category, stage, or
                            impact.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4">
                      <div class="ct_how_work_card">
                        <img
                          src="../assets/img/fa6-solid_handshake.png"
                          alt=""
                          className="ct_w_50_340"
                        />
                        <div class="pt-4">
                          <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                            Connect with Founders
                          </h5>
                          <p
                            class="mb-0 ct_fs_16"
                            style={{ maxWidth: "256px" }}
                          >
                            Reach out directly or request intros through Nuvio
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4">
                      <div class="ct_how_work_card">
                        <img
                          src="../assets/img/uim_bag.png"
                          alt=""
                          className="ct_w_50_340"
                        />
                        <div class="pt-4">
                          <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                            Support Grow
                          </h5>
                          <p
                            class="mb-0 ct_fs_16"
                            style={{ maxWidth: "256px" }}
                          >
                            Invest, mentor, or partner-track progress along the
                            way.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section
            class="ct_coach_created_bg mt-0 ct_px_40 ct_py_130"
            style={{ backgroundColor: "hsl(199deg 64% 73% / 20%)" }}
          >
            <div class="container">
              <div class="row">
                <div class="col-lg-4  mb-4 mb-lg-0">
                  <label class="ct_learn_img d-block">
                    <img
                      src={"/assets/img/meet_nellie_img.png"}
                      alt=""
                      style={{ height: "400px" }}
                    />
                  </label>
                </div>
                <div class="col-lg-8 mb-4 mb-lg-0 ps-lg-5">
                  <div class="d-flex align-items-end gap-3 ct_flex_col_575">
                    <div>
                      <h4 class="ct_fs_28 ct_yellow_text mb-4 ct_yellow_text">
                        Meet Nellie Padilla
                      </h4>
                      {/* <p class="ct_fs_22 mb-0">
                        Founder Coach | Startup Strategist | Growth Guide
                      </p> */}
                      <div class="mt-4">
                        <p class="ct_fs_20 mb-3" style={{ maxWidth: "545px" }}>
                          Nellie is an educator turned social entrepreneur passionate about bridging the gap between rural communities and digital learning.
                        </p>
                        <br />
                        <p class="ct_fs_20 mb-3" style={{ maxWidth: "545px" }}>
                          After years of teaching in underserved schools, she
                          launched the{" "}
                          <span class="ct_yellow_text">
                            Solar Learning Initiative
                          </span>{" "}
                          to bring reliable power and quality education to areas
                          left behind
                        </p>
                      </div>
                      <div class="mt-5">
                        <a data-bs-target="#ct_back_this_founder_modal"
                          data-bs-toggle="modal" class="ct_yellow_btn ct_yellow_bg ct_fit_content px-5 mx-auto">
                          Contact Nellie
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section
            data-aos="fade-left"
            data-aos-duration="1500"
            class="ct_looking_for_work_bg ct_mb_100  ct_mt_100"
            style={{
              paddingTop: "147px",
              paddingBottom: "144px",
              backgroundColor: "#FFB703",
            }}
          >
            <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
              <div class="text-white">
                <h4 class="ct_fs_36 mb-4">Ready to Make a Difference?</h4>
                <p class="mb-0 ct_fs_18 ct_fw_300">
                  Whether you invest capital or partnership your support helps
                  this ides scale faster and smarter.
                </p>
              </div>
              <div class="ct_flex_shrink_0 ms-lg-auto">
                <a
                  class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
                  data-bs-target="#ct_back_this_founder_modal"
                  data-bs-toggle="modal"
                >
                  Back a Founder Today
                </a>
              </div>
            </div>
          </section>

          <section className="ct_px_40 ct_mt_130">
            <div className="container-fluid">
              <div className="row ">
                <div
                  className="col-xxl-5 col-xl-5 col-lg-5 mb-4 mb-lg-0 "
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <div className="ct_minus_mt_40">
                    <img
                      src="../assets/img/Rectangle_4195_new_1234.png"
                      className="ct_img_h_400"
                    />
                  </div>
                </div>
                <div
                  className="col-xxl-7 col-xl-7 col-lg-7  ps-xl-5 mb-4 mb-lg-0"
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <div className="">
                    <h4 className="ct_fs_32 ct_mb_30 ct_darkblue_text ct_text_op_8">
                      How Can You Support Our Growth?
                    </h4>
                    <p
                      className="ct_fs_20_new  ct_para_scroll ct_custom_scroll ct_darkblue_text"
                      style={{ maxWidth: "572px" }}
                    >
                      Partner with us to transform the future of learning
                      through innovative structure solutions.
                    </p>
                    <ul className="ct_mt_30 ct_para_scroll ct_custom_scroll">
                      <li className="ct_fs_20_new ct_darkblue_text">
                        <span
                          className="ct_dot_10 me-2"
                          style={{ backgroundColor: "#FFB703" }}
                        ></span>{" "}
                        Type of support needed : Equity, grants and partnership
                      </li>
                      <li className="mt-2 ct_fs_20_new ct_darkblue_text">
                        <span
                          className="ct_dot_10 me-2"
                          style={{ backgroundColor: "#FFB703" }}
                        ></span>{" "}
                        Impact-driven individuals or firms
                      </li>
                      <li className="mt-2 ct_fs_20_new ct_darkblue_text">
                        <span
                          className="ct_dot_10 me-2"
                          style={{ backgroundColor: "#FFB703" }}
                        ></span>{" "}
                        Committed to long-term, sustainable development
                      </li>
                      <li className="mt-2 ct_fs_20_new ct_darkblue_text">
                        <span
                          className="ct_dot_10 me-2"
                          style={{ backgroundColor: "#FFB703" }}
                        ></span>{" "}
                        Partnership & mentorship opportunities
                      </li>
                    </ul>
                    <div className="ct_mt_30">
                      <button
                        className="ct_yellow_btn "
                        data-bs-target="#ct_back_this_founder_modal"
                        data-bs-toggle="modal"
                      >
                        Back This Founder
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section
            class="  ct_px_40   ct_mt_130"
            style={{ backgroundColor: "#F5F3EF", paddingBlock: "72px" }}
          >
            <div class="container-fluid">
              <div class="row">
                <div
                  class="col-lg-4 mb-4 mb-lg-0"
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <div class="d-grid h-100 pt-2 pb-5">
                    <h2
                      class="ct_fs_40 ct_darkblue_text"
                      style={{ maxWidth: "300px" }}
                    >
                      Real Stories, real{" "}
                      <span class="ct_yellow_text">success</span>
                    </h2>
                    <div className="ct_arrows mt-auto">
                      <button className="ct_prev ct_arrow_btn" ref={prevRef}>
                        <i class="fa-solid fa-arrow-left"></i>
                      </button>
                      <button className="ct_next ct_arrow_btn" ref={nextRef}>
                        <i class="fa-solid fa-arrow-right"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  class="col-lg-8 mb-4 mb-lg-0"
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <Swiper
                    modules={[Navigation, Autoplay]}
                    spaceBetween={20}
                    slidesPerView={1}
                    loop={true}
                    autoplay={{ delay: 2500 }}
                    navigation={{
                      prevEl: prevRef.current,
                      nextEl: nextRef.current,
                    }}
                    onBeforeInit={(swiper) => {
                      swiper.params.navigation.prevEl = prevRef.current;
                      swiper.params.navigation.nextEl = nextRef.current;
                    }}
                    className="ct_real_stories_slider"
                  >
                    {/* Slide 1 */}
                    <SwiperSlide>
                      <div className="ct_story_slide_card">
                        <div className="ct_story_user_img">
                          <img
                            src="../assets/img/reacl_stories_img_slider_123.png"
                            alt=""
                          />
                        </div>
                        <div>
                          <div className="ct_orange_text mb-3">
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                          </div>

                          <h3 className="ct_fs_20 ct_darkblue_text mb-3">
                            From Passion to Profession
                          </h3>

                          <p
                            className="ct_fS_18 ct_darkblue_text"
                            style={{ maxWidth: "402px" }}
                          >
                            Starting as a freelance developer felt overwhelming.
                            But through NuGlow, I built a solid portfolio and
                            connected with startups that valued my work. Today,
                            I lead a team and help others find their way too.
                          </p>

                          <div className="mt-5">
                            <h4 className="ct_fs_20 ct_darkblue_text">
                              Amelia Carter
                            </h4>
                            <p className="ct_fs_18 ct_darkblue_text">
                              Head of Product at BrightWave Solutions
                            </p>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="ct_story_slide_card">
                        <div className="ct_story_user_img">
                          <img
                            src="../assets/img/reacl_stories_img_slider_123.png"
                            alt=""
                          />
                        </div>
                        <div>
                          <div className="ct_orange_text mb-3">
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                          </div>

                          <h3 className="ct_fs_20 ct_darkblue_text mb-3">
                            From Passion to Profession
                          </h3>

                          <p
                            className="ct_fS_18 ct_darkblue_text"
                            style={{ maxWidth: "402px" }}
                          >
                            Starting as a freelance developer felt overwhelming.
                            But through NuGlow, I built a solid portfolio and
                            connected with startups that valued my work. Today,
                            I lead a team and help others find their way too.
                          </p>

                          <div className="mt-5">
                            <h4 className="ct_fs_20 ct_darkblue_text">
                              Amelia Carter
                            </h4>
                            <p className="ct_fs_18 ct_darkblue_text">
                              Head of Product at BrightWave Solutions
                            </p>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="ct_story_slide_card">
                        <div className="ct_story_user_img">
                          <img
                            src="../assets/img/reacl_stories_img_slider_123.png"
                            alt=""
                          />
                        </div>
                        <div>
                          <div className="ct_orange_text mb-3">
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                          </div>

                          <h3 className="ct_fs_20 ct_darkblue_text mb-3">
                            From Passion to Profession
                          </h3>

                          <p
                            className="ct_fS_18 ct_darkblue_text"
                            style={{ maxWidth: "402px" }}
                          >
                            Starting as a freelance developer felt overwhelming.
                            But through NuGlow, I built a solid portfolio and
                            connected with startups that valued my work. Today,
                            I lead a team and help others find their way too.
                          </p>

                          <div className="mt-5">
                            <h4 className="ct_fs_20 ct_darkblue_text">
                              Amelia Carter
                            </h4>
                            <p className="ct_fs_18 ct_darkblue_text">
                              Head of Product at BrightWave Solutions
                            </p>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="ct_story_slide_card">
                        <div className="ct_story_user_img">
                          <img
                            src="../assets/img/reacl_stories_img_slider_123.png"
                            alt=""
                          />
                        </div>
                        <div>
                          <div className="ct_orange_text mb-3">
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                          </div>

                          <h3 className="ct_fs_20 ct_darkblue_text mb-3">
                            From Passion to Profession
                          </h3>

                          <p
                            className="ct_fS_18 ct_darkblue_text"
                            style={{ maxWidth: "402px" }}
                          >
                            Starting as a freelance developer felt overwhelming.
                            But through NuGlow, I built a solid portfolio and
                            connected with startups that valued my work. Today,
                            I lead a team and help others find their way too.
                          </p>

                          <div className="mt-5">
                            <h4 className="ct_fs_20 ct_darkblue_text">
                              Amelia Carter
                            </h4>
                            <p className="ct_fs_18 ct_darkblue_text">
                              Head of Product at BrightWave Solutions
                            </p>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  </Swiper>
                </div>
              </div>
            </div>
          </section>

          <section class=" ct_px_40  ct_py_130 pb-0 ">
            <div class="container-fluid">
              <div class="row align-items-center">
                <div
                  class="col-xxl-7 col-xl-7 col-md-6 mb-4 mb-md-0 "
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <div class="ct_about_cnt">
                    <h2 class=" ct_fs_32  ct_mb_60">
                      Frequently asked questions
                    </h2>

                    <div class="ct_faq_question_main ">
                      <div class="accordion" id="faq_accordionExample">
                        <div class="accordion-item">
                          <h2 class="accordion-header" id="faq_one">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapsefaq_one"
                              aria-expanded="false"
                              aria-controls="collapsefaq_one"
                            >
                              Who handles the actual funding process?
                            </button>
                          </h2>
                          <div
                            id="collapsefaq_one"
                            class="accordion-collapse collapse"
                            aria-labelledby="faq_one"
                            data-bs-parent="#faq_accordionExample"
                          >
                            <div class="accordion-body">
                              <p class="ct_fs_20 mb-0 ct_line_h_30">
                                Simply sign up for an account, create your
                                profile highlighting your skills and experience,
                                and start browsing or applying for projects that
                                interest you.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item">
                          <h2 class="accordion-header" id="faqtwo">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapsefaq_Two"
                              aria-expanded="true"
                              aria-controls="collapseTwo"
                            >
                              Is this a grant, equity, or donation model?
                            </button>
                          </h2>
                          <div
                            id="collapsefaq_Two"
                            class="accordion-collapse collapse "
                            aria-labelledby="faqtwo"
                            data-bs-parent="#faq_accordionExample"
                          >
                            <div class="accordion-body">
                              <p class="ct_fs_20 mb-0 ct_line_h_30">
                                Simply sign up for an account, create your
                                profile highlighting your skills and experience,
                                and start browsing or applying for projects that
                                interest you.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item">
                          <h2 class="accordion-header" id="faqthree">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapsefaq_Three"
                              aria-expanded="false"
                              aria-controls="collapsefaq_Three"
                            >
                              Can I speak with the founder before committing?
                            </button>
                          </h2>
                          <div
                            id="collapsefaq_Three"
                            class="accordion-collapse collapse"
                            aria-labelledby="faqthree"
                            data-bs-parent="#faq_accordionExample"
                          >
                            <div class="accordion-body">
                              <p class="ct_fs_20 mb-0 ct_line_h_30">
                                Simply sign up for an account, create your
                                profile highlighting your skills and experience,
                                and start browsing or applying for projects that
                                interest you.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item">
                          <h2 class="accordion-header" id="faqFour">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapsefaq_Four"
                              aria-expanded="false"
                              aria-controls="collapsefaq_Four"
                            >
                              What happens after i click “Back This Founder”?
                            </button>
                          </h2>
                          <div
                            id="collapsefaq_Four"
                            class="accordion-collapse collapse"
                            aria-labelledby="faqFour"
                            data-bs-parent="#faq_accordionExample"
                          >
                            <div class="accordion-body">
                              <p class="ct_fs_20 mb-0 ct_line_h_30">
                                Simply sign up for an account, create your
                                profile highlighting your skills and experience,
                                and start browsing or applying for projects that
                                interest you.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="col-xxl-4  col-xl-5 col-md-6 mb-4 mb-md-0 ps-xl-5 "
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <div class="ct_about_img">
                    <img
                      src="../assets/img/pexels-fauxels-318283_new_123.png"
                      class="ct_img_h_617"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section
            data-aos="fade-right"
            data-aos-duration="1500"
            class="ct_looking_for_work_bg ct_looking_for_work_bg_left  ct_mt_100"
            style={{ backgroundColor: "#8ECAE6", paddingBlock: "134px" }}
          >
            <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
              <div class="text-white">
                <h4 class="ct_fs_36 mb-4">Ready to Make a Difference?</h4>
                <p
                  class="mb-0 ct_fs_18 ct_fw_300"
                  style={{ maxWidth: "680px" }}
                >
                  Whether you invest capital or partnership your support helps
                  this ides scale faster and smarter.
                </p>
              </div>
              <div class="ct_flex_shrink_0 ms-lg-auto">
                <a
                  class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
                  data-bs-target="#ct_back_this_founder_modal"
                  data-bs-toggle="modal"
                // onClick={() => navigate(coachPaths?.ContactUs)}
                >
                  Back a Founder Today
                </a>
              </div>
            </div>
          </section>

          <div
            class="modal fade modal-lg"
            id="ct_back_this_founder_modal"
            tabindex="-1"
            aria-labelledby="ct_back_this_founder_modalLabel"
            aria-hidden="true"
          >
            <div
              class="modal-dialog modal-dialog-centered"
              style={{ maxWidth: "600px" }}
            >
              <div class="modal-content ct_border_radius_20">
                <div class="modal-header border-0">
                  <button
                    type="button"
                    class="btn-close ct_circle_close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div class="modal-body p-0 px-md-5">
                  <h4 class=" mb-1 ct_fs_18 text-center  px-4">
                    Express Your Interest In <br />
                    <span style={{ color: "#FFB703" }}>
                      “Solar Learning Initiative”
                    </span>
                  </h4>

                  <form
                    action="javascript:void(0)"
                    class="mt-4 ct_modal_scroll ct_custom_scroll "
                  >
                    <div class="row  px-4">
                      <div class="col-md-12">
                        <div class="form-group mb-4">
                          <label for="" class="d-block mb-2">
                            Name
                          </label>
                          <input
                            type="text"
                            class="form-control ct_input"
                            placeholder="Name"
                          />
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group mb-4">
                          <label for="" class="d-block mb-2">
                            Email
                          </label>
                          <input
                            type="email"
                            class="form-control ct_input"
                            placeholder="Email"
                          />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group mb-4">
                          <label for="" class="d-block mb-2">
                            Type Of Support
                          </label>
                          <select className="form-control ct_input">
                            <option>Equity</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group mb-4">
                          <label for="" class="d-block mb-2">
                            Proposed Amount
                          </label>
                          <select className="form-control ct_input">
                            <option>Proposed Amount</option>
                          </select>
                        </div>
                      </div>

                      <div class="col-md-12">
                        <div class="form-group mb-4">
                          <label for="" class="d-block mb-2">
                            Notes(Optional)
                          </label>
                          <textarea
                            class="form-control ct_input h-auto"
                            rows="4"
                            placeholder="Let the coach know what you will like to focus on....."
                          ></textarea>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex align-items-center gap-3 justify-content-center pt-3">
                      <button class=" ct_yellow_btn px-5 py-2">
                        Submit Interest
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div
            class="modal fade modal-lg"
            id="ct_contact_founder_modal"
            tabindex="-1"
            aria-labelledby="ct_contact_founder_modalLabel"
            aria-hidden="true"
          >
            <div
              class="modal-dialog modal-dialog-centered"
              style={{ maxWidth: "600px" }}
            >
              <div class="modal-content ct_border_radius_20 ">
                <div class="modal-header border-0">
                  <button
                    type="button"
                    class="btn-close ct_circle_close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div class="modal-body p-0 px-md-5">
                  <h4 class=" mb-1 ct_fs_18 text-center  px-4">
                    Send a Message to{" "}
                    <span className="ct_yellow_text">Nellie Padille</span>
                  </h4>

                  <form
                    action="javascript:void(0)"
                    class="mt-4 ct_modal_scroll ct_custom_scroll "
                  >
                    <div class="row  px-4">
                      <div class="col-md-12">
                        <div class="form-group mb-4">
                          <label for="" class="d-block mb-2">
                            Name
                          </label>
                          <input
                            type="text"
                            class="form-control ct_input"
                            placeholder="Name"
                          />
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group mb-4">
                          <label for="" class="d-block mb-2">
                            Email
                          </label>
                          <input
                            type="email"
                            class="form-control ct_input"
                            placeholder="Email"
                          />
                        </div>
                      </div>

                      <div class="col-md-12">
                        <div class="form-group mb-4">
                          <label for="" class="d-block mb-2">
                            Message
                          </label>
                          <textarea
                            class="form-control ct_input h-auto"
                            rows="4"
                            placeholder="Ask about the project, collaboration, or offer feedback..."
                          ></textarea>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex align-items-center gap-3 justify-content-center pt-3">
                      <button class=" ct_yellow_btn px-5 py-2">
                        Send Message
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </MenuLayout>
  );
};

export default FundingProjectFullDetail;
